import React, { useEffect } from 'react'
import InputController from '../../Global/InputController'

const SurveyResponseForm = ({
  questionId,
  optionsForResponse,
  responses,
  typeQuestion,
  control,
  prefix,
  setValue,
  questionValues,
}) => {
  useEffect(() => {
    if (responses && responses.length > 0) {
      responses.forEach((option, idx) => {
        // console.log('option', option)
        if (typeQuestion === 'multi-choice') {
          setValue(
            `${prefix}[${option.question_option_id}].answer_text`,
            option.answer_text
          )
          setValue(
            `${prefix}[${option.question_option_id}].answer_value`,
            option.question_option_id
          )
        }

        if (typeQuestion === 'open-question') {
          setValue(
            `${prefix}[${option.question_id}].answer_text`,
            option.answer_text
          )
        }

        if (typeQuestion === 'choosen') {
          console.log('option', option)
          setValue(
            `${prefix}[${option.question_id}].answer_text`,
            option.answer_text
          )
        }
      })
    }
  }, [responses])

  useEffect(() => {
    if (questionValues && typeQuestion === 'raiting') {
      if (questionValues.value) {
        // console.log('questionValues', questionValues)
        document.getElementById(`min-${questionId}`).innerText =
          questionValues.min
        document.getElementById(`max-${questionId}`).innerText =
          questionValues.max
      }
    }
  }, [questionValues])

  return (
    <React.Fragment key={questionId}>
      {typeQuestion === 'multi-choice' && (
        <>
          <div
            className="row"
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              marginLeft: '26px',
            }}
          >
            {optionsForResponse.length > 0 &&
              optionsForResponse.map((option, idx) => {
                return (
                  <>
                    <div
                      className="form-check form-check-inline col-lg-3"
                      style={{
                        padding: '0 0 10px 0',
                        // display: 'flex',
                        color: 'black',
                        fontSize: '1.1rem',
                      }}
                      key={option.id}
                    >
                      <InputController
                        id={option.id}
                        // label={option.option_text}
                        name={`${prefix}[${option.id}].answer_text`}
                        control={control}
                        inputType="checkbox"
                        addClass="form-check-input"
                        style={{ cursor: 'pointer', width: '17px' }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={option.id}
                        style={{
                          cursor: 'pointer',
                        }}
                      >
                        {`${option.option_text}`}
                      </label>
                    </div>
                    <InputController
                      type="hidden"
                      name={`${prefix}[${option.id}].answer_value`}
                      valueManual={option.id}
                      control={control}
                    />
                  </>
                )
              })}
          </div>
        </>
      )}
      {typeQuestion === 'open-question' && (
        <>
          <div className="form-group" key={questionId}>
            <InputController
              label="Respuesta"
              name={`${prefix}[${questionId}].answer_text`}
              control={control}
              inputType="textarea"
            />
          </div>
        </>
      )}
      {typeQuestion === 'raiting' && (
        <>
          <div className="container col-12">
            <div className="row align-items-center">
              <div className="col text-center">
                <div className="d-flex justify-content-between">
                  {optionsForResponse.map((option, index) => (
                    <>
                      {+option.value !== 1 && (
                        <>
                          {[...Array(+option.value)].map((_, idx) => (
                            <div key={idx} className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name={`flexRadioDefault${questionId}[${parseInt(
                                  idx
                                )}]`}
                                id={`flexRadioDefault${questionId}[${parseInt(
                                  idx
                                )}]`}
                                checked={
                                  responses.length > 0 &&
                                  responses[0].answer_text == idx + 1
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`flexRadioDefault${questionId}[${parseInt(
                                  idx
                                )}]`}
                              >
                                {idx + 1}
                              </label>
                              {idx === 0 && (
                                <div
                                  className="col-lg-12"
                                  style={{ left: '0' }}
                                >
                                  <p id={`min-${questionId}`}>
                                    {option.option_text}
                                  </p>
                                </div>
                              )}
                              {idx === option.value - 1 && (
                                <div
                                  className="col-lg-12"
                                  style={{ right: '0' }}
                                >
                                  <p id={`max-${questionId}`}>
                                    {option.option_text}
                                  </p>
                                </div>
                              )}
                            </div>
                          ))}
                        </>
                      )}
                    </>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {typeQuestion === 'choosen' && (
        <>
          {/* {optionsForResponse.length > 0 &&
            optionsForResponse.map((option, idx) => {
              return ( */}
          <div className="row">
            <div className="col-lg-6">
              <InputController
                label="Respuesta"
                name={`${prefix}[${questionId}].answer_text`}
                control={control}
                inputType="choosen"
                options={optionsForResponse.map((option) => {
                  return {
                    value: option.id,
                    label: option.option_text,
                  }
                })}
                placeholderTxt="Elija una opción"
              />
            </div>
          </div>
          {/* )
             })} */}
        </>
      )}
    </React.Fragment>
  )
}

export default SurveyResponseForm
